module.exports = __webpack_public_path__ + "f2e304ec762ee387156a7b14bcb3810f.jpg";